import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Mail, Phone, MessageSquare } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast.success("Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.");
    setFormData({ name: "", email: "", phone: "", message: "" });
  };
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const contactMethods = [
    {
      icon: Mail,
      title: "Email",
      value: "contact@fruitycall.fr",
      description: "Réponse sous 24h"
    },
    {
      icon: Phone,
      title: "Téléphone",
      value: "01 23 45 67 89",
      description: "Lun-Ven 9h-18h"
    },
    {
      icon: MessageSquare,
      title: "Support",
      value: "support@fruitycall.fr",
      description: "Assistance technique"
    }
  ];
  
  return (
    <div className="flex min-h-screen flex-col">
      <PublicHeader />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="section-spacing bg-gradient-to-br from-primary/5 via-background to-secondary/10">
          <div className="container-custom text-center">
            <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl">
              Contactez-nous
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
              Notre équipe est à votre écoute pour répondre à toutes vos questions
            </p>
          </div>
        </section>
        
        {/* Contact Methods */}
        <section className="section-spacing">
          <div className="container-custom">
            <div className="mb-16 grid gap-8 md:grid-cols-3">
              {contactMethods.map((method, index) => {
                const Icon = method.icon;
                return (
                  <Card key={index} className="border-2 text-center">
                    <CardContent className="flex flex-col items-center p-8">
                      <div className="mb-4 rounded-full bg-primary/10 p-4">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <h3 className="mb-2 text-lg font-semibold">{method.title}</h3>
                      <p className="mb-1 font-medium text-foreground">{method.value}</p>
                      <p className="text-sm text-muted-foreground">{method.description}</p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
            
            {/* Contact Form */}
            <div className="mx-auto max-w-2xl">
              <Card className="border-2">
                <CardContent className="p-8">
                  <h2 className="mb-6 text-2xl font-bold">Envoyez-nous un message</h2>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid gap-6 sm:grid-cols-2">
                      <div className="space-y-2">
                        <Label htmlFor="name">Nom complet *</Label>
                        <Input
                          id="name"
                          name="name"
                          placeholder="Dr. Jean Dupont"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="phone">Téléphone</Label>
                        <Input
                          id="phone"
                          name="phone"
                          type="tel"
                          placeholder="01 23 45 67 89"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    
                    <div className="space-y-2">
                      <Label htmlFor="email">Email *</Label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="votre@email.fr"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="space-y-2">
                      <Label htmlFor="message">Message *</Label>
                      <Textarea
                        id="message"
                        name="message"
                        placeholder="Décrivez votre demande..."
                        rows={6}
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <Button type="submit" size="lg" className="w-full">
                      Envoyer le message
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>
      
      <PublicFooter />
    </div>
  );
};

export default Contact;